<template>
    <div class="rounded-muval-2 flex flex-col gap-4 bg-gray-50 p-4">
        <div class="flex items-baseline gap-2">
            <div class="text-muval-gray-1 text-base font-medium">Price breakdown</div>
            <span class="text-muval-gray-2 text-xs">{{ displayPricesExTax ? 'excludes GST' : 'includes GST' }}</span>
        </div>
        <div class="flex flex-col divide-y divide-gray-200">
            <div
                v-for="(item, idx) in breakdownItems"
                :key="idx"
                class="flex flex-col pt-3 pb-3 first:pt-0 last:pb-0"
            >
                <div class="flex items-baseline justify-between">
                    <div class="text-muval-gray-1 flex items-center gap-2 text-xs font-medium">
                        <SvgIcon
                            v-if="item.icon"
                            :name="item.icon"
                            color="currentColor"
                            class="size-3.5 shrink-0"
                            data-testid="price-breakdown-service-icon"
                        />
                        {{ item.label }}
                    </div>
                    <div
                        v-if="item.unitCost"
                        class="text-muval-gray-1 text-right text-xs"
                    >
                        {{ item.unitCost }}
                    </div>
                </div>

                <PriceBreakdownRow
                    v-for="(row, rowIdx) in item.rows"
                    :key="rowIdx"
                    :row="row"
                    size="xs"
                />
            </div>
        </div>

        <div class="flex items-center justify-between border-t border-gray-200 pt-3">
            <div class="text-muval-gray-1 text-sm font-medium">Due now</div>
            <div class="text-muval-gray-1 text-base font-semibold">{{ dueNowTotal }}</div>
        </div>
    </div>
</template>

<script setup>
import { usePriceBreakdown } from '@/composables/usePriceBreakdown';
import PriceBreakdownRow from '@/components/PriceBreakdownRow.vue';
import SvgIcon from '@/components/utilities/SvgIcon.vue';

const props = defineProps({
    orderItemIds: {
        type: Array,
        required: false,
        default: () => [],
    },
});

const { breakdownItems, dueNowTotal, displayPricesExTax } = usePriceBreakdown({
    orderItemIds: props.orderItemIds,
});
</script>
